import { render, staticRenderFns } from "./shouzhi.vue?vue&type=template&id=47faa089&scoped=true"
import script from "./shouzhi.vue?vue&type=script&lang=js"
export * from "./shouzhi.vue?vue&type=script&lang=js"
import style0 from "./shouzhi.vue?vue&type=style&index=0&id=47faa089&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47faa089",
  null
  
)

export default component.exports